/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-hover-background-color',
  templateUrl: './theme-option-elements-hover-background-color.component.html',
  styleUrls: ['./theme-option-elements-hover-background-color.component.css']
})
export class ThemeOptionElementsHoverBackgroundColorComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() serieIndex: number;

  showDetails: boolean;
  color = ItemColor('themes');
  opacity: number;
  hoverBackgroundColor: string;
  optionType: ThemeOptionType = 'elements_hoverBackgroundColor';

  constructor() {
    this.showDetails = false;
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  ngOnInit() {
    this.hoverBackgroundColor = this.themeOptions.series(this.serieIndex).hoverBackgroundColor.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.series(this.serieIndex).hoverBackgroundColor.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.hoverBackgroundColor = value;
    this.themeOptions.setSeries(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.serieIndex);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) {
      this.themeOptions.setSeries(this.optionType, this.hoverBackgroundColor + Math.round(value * 255 / 100).toString(16), this.serieIndex);
    }
    else {
      this.themeOptions.setSeries(this.optionType, this.hoverBackgroundColor + '00', this.serieIndex);
    }
  }

}
